import { SxProps, Theme } from '@mui/material';

export const distributorNavbarFrameSX: SxProps<Theme> = {
	position: 'relative',
	backgroundColor: '#0087DB',
	display: 'flex',
	flexDirection: 'row',
	justifyContent: 'space-between',
	alignItems: 'center',
	padding: '12px 8px',
};

export const distributorNavbarContentSX: SxProps<Theme> = {
	display: 'flex',
	flexDirection: 'row',
	alignItems: 'center',
	gap: '6px',
};

export const distributorNavbarNameSX: SxProps<Theme> = {
	color: 'white',
	fontSize: '16px',
	fontWeight: 'bold',
	lineHeight: '19px',
};

export const distributorNavbarAvatarFrameSX: SxProps<Theme> = {
	position: 'relative',
};

export const distributorNavbarAvatarSX: SxProps<Theme> = { width: '26px', height: '26px' };

export const distributorNavbarArrowsSX: SxProps<Theme> = {
	position: 'absolute',
	bottom: '-11px',
	left: '9px',
	width: '0px',
	height: '0px',
	borderLeft: '12px solid transparent',
	borderRight: '12px solid transparent',
	borderTop: '12px solid #0087DB',
	zIndex: 9998,
};

export const distributorNavbarButtonSX: SxProps<Theme> = {
	width: 'auto',
	color: 'white',
	fontSize: '14px',
	display: 'flex',
	flexDirection: 'row',
	alignItems: 'center',
	gap: '5px',
};

export const distributorNavbarHelpIconSX: SxProps<Theme> = { color: 'white' };

export const distributorNavbarWarningIconSX: SxProps<Theme> = { color: 'white', fontSize: '18px' };

export const distributorNavbarTutorialButtonSX: SxProps<Theme> = {
	marginRight: '10px',
};
